import type { UploadResponse } from '../../lib/trpc';
import { labelFor } from '../../lib/canonical';

/**
 * Estado distinto de "tem pendências para revisar": aqui o agente NÃO achou
 * colunas essenciais (ex.: comprador ou valor), então o arquivo não serve como
 * está. Orientamos o cliente a ajustar e tentar de novo.
 */
export function MappingFailureState({
  res,
  onRetry,
  onVoltar,
}: {
  res: UploadResponse;
  onRetry: () => void;
  onVoltar: () => void;
}) {
  return (
    <div className="card px-8 py-12">
      <div className="text-center">
        <div
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full"
          style={{ background: 'var(--risk-soft)' }}
        >
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
            <path d="M9 9l6 6m0-6l-6 6M12 21a9 9 0 100-18 9 9 0 000 18z"
              stroke="var(--risk)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-ink">Faltam colunas essenciais</h2>
        <p className="mx-auto mt-2 max-w-lg text-sm text-ink-3">
          O agente leu <span className="text-ink-2">{res.nomeArquivo}</span>, mas não encontrou
          colunas que identificam campos obrigatórios. Sem elas, não dá para organizar a carteira.
        </p>
      </div>

      <div className="mx-auto mt-6 max-w-md rounded-sm border border-line p-4">
        <div className="mb-2 text-xs uppercase tracking-wide text-ink-4">Campos não encontrados</div>
        <ul className="space-y-1">
          {res.requiredMissing.map((k) => (
            <li key={k} className="flex items-center gap-2 text-sm text-ink-2">
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--risk)' }} />
              {labelFor(k)}
            </li>
          ))}
        </ul>
        <p className="mt-3 text-xs text-ink-3">
          Garanta que a planilha tenha colunas com o nome do comprador, a unidade e o valor do
          contrato (uma por linha de cabeçalho) e tente novamente.
        </p>
      </div>

      <div className="mt-6 flex justify-center gap-3">
        <button className="btn btn-ghost" onClick={onVoltar}>
          Voltar
        </button>
        <button className="btn btn-primary" onClick={onRetry}>
          Subir arquivo corrigido
        </button>
      </div>
    </div>
  );
}
